module.exports = __webpack_public_path__ + "img/08.9700e640.png";